export default {
 ADD_ACHIEVEMENT(state,payload){
    state.add_achievements = payload
  },
  SET_ACHIEVEMENT(state, payload) {
    state.achievements=payload
  },
  EDIT_ACHIEVEMENT(state,payload){
    state.edit_achievement=payload
    }
};
